// src/hooks/useCategories.js
import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

// The tool taxonomy. It changes only when someone edits the backend config,
// so there's no reason to refetch it during a session.
export const useCategories = () => {
  const { data: categories = [], isLoading } = useQuery({
    queryKey: ['categories'],
    queryFn: async () => {
      const response = await api.get('/tools/categories');
      return response.data;
    },
    staleTime: Infinity,
  });

  return { categories, isLoading };
};
